import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Лыжный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Разновидность спортивного туризма, предусматривающая прохождение маршрута на лыжах по равнинам и
                        возвышенностям.</p>
                    <p>Лыжный туризм требует специальной подготовки участников и повышенного внимания организаторов.</p>
                </div>
            </div>
        </>
    );
}